module.exports = __webpack_public_path__ + "img/reporting_group_drivers.6fd4144b.svg";